export default __webpack_public_path__ + "static/media/main_section1.2ebe3d56.jpg";